// ============================================================
// HostingV3 — visual language tokens extracted from the prototype.
//
// Scoped to the Hosting / DNS surface so the premium treatment
// does not leak into the rest of the shell. Uses the same palette
// as the project's shell styles but with the Jordan prototype's
// color rhythm.
// ============================================================

export const V3 = {
  pur: '#7b5ea7',
  cyan: '#00aad2',
  grn: '#00a67d',
  red: '#e85d3a',
  ora: '#E8854A',
  gld: '#c4a24e',
  blue: '#5B9FD4',
  w: '#edf2ff',
  w2: '#9ca8c0',
  w3: '#556078',
  bg: '#000000',
  mono: "'JetBrains Mono','SF Mono',monospace",
} as const
